/**
 * Patient portal, staff side (docs/portal/README.md): the request queue,
 * accounts and invites, per-office settings and the access log. The patient
 * app is `apps/portal-web`.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'portal',
    title: 'Patient portal',
    version: '0.1.0',
    owner: 'WP5-PORTAL',
    entitlementKey: null,
    permissions: [
      'task.view',
      'task.create',
      'settings.manage',
      'comms.send',
      'audit.view',
      'patient.view',
      'patient.portal_preview',
    ],
    routes: [
      {
        id: 'home',
        path: '/portal',
        title: 'Patient portal',
        officeScope: 'location',
        permission: 'task.view',
        readsPhi: true,
      },
      {
        // Settings > Patient portal (SettingsFrame lists it under Connections).
        id: 'settings',
        path: '/settings/patient-portal',
        title: 'Patient portal settings',
        officeScope: 'location',
        permission: 'settings.manage',
      },
    ],
    nav: [
      {
        label: 'Patient portal',
        group: 'patients',
        routeId: 'home',
        icon: 'users-round',
        order: 40,
      },
    ],
    commands: [
      {
        id: 'portal.open',
        title: 'Open patient portal requests',
        keywords: [
          'portal',
          'patient portal',
          'requests',
          'invite',
          'records request',
          'access log',
        ],
        routeId: 'home',
      },
      {
        id: 'portal.settings',
        title: 'Patient portal settings',
        keywords: ['portal', 'patient portal', 'branding', 'sign in', 'cards', 'features'],
        routeId: 'settings',
        permission: 'settings.manage',
      },
    ],
    sseEntityKeys: ['portal_request'],
  }),
  pages: {
    home: () => import('./PortalPage.js'),
    settings: () => import('./PortalSettingsPage.js'),
  },
});
